"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.resolveFieldType = exports.resolveId = exports.resolveKey = exports.resolveField = exports.AFFILIATION_DS_OVERRIDES = void 0;
exports.AFFILIATION_DS_OVERRIDES = {
    'affiliated-facility': 'facility',
    'affiliated-health-system': 'health-system',
    'affiliated-payer': 'payer',
    'affiliated-org': 'org'
};
function resolveField(field, datasetName, datasetByName) {
    /**
     * There are 6 use cases:
     * 1. dataset:field_name                    (zip-geo:fips)
     * 2. dataset::field_type
     *     a. dataset exists                    (hospital::key)
     *     b. dataset doesn't exist             (year-month::key)
     * 3. dataset::field_type::override_name    (health-system::id::affiliated_health_system_id)
     * 4. field_name                            (drg_group)
     * 5. ::field_type                          (::id)
     */
    let parts = field.split('::');
    if (parts.length > 1) {
        if (!parts[0]) {
            // Use case 5
            let datasetDef = datasetByName[datasetName];
            return [datasetDef.name, resolveFieldType(parts[1], datasetDef)];
        }
        else if (parts.length === 3) {
            // Use case 3
            let datasetDef = datasetByName[parts[0]];
            let field = resolveFieldType(parts[1], datasetDef);
            return [datasetDef.name, field, parts[2]];
        }
        else {
            let datasetDef = datasetByName[parts[0]];
            if (datasetDef) {
                // Use case 2a
                return [datasetDef.name, resolveFieldType(parts[1], datasetDef)];
            }
            else {
                // Use case 2c
                return [null, parts[0].replace(/-/g, '_') + '_' + parts[1]];
            }
        }
    }
    else {
        parts = field.split(':');
        if (parts.length > 1) {
            // Use case 1
            return [parts[0], parts[1]];
        }
        else {
            // Use case 4
            let datasetDef = datasetByName[datasetName];
            return [datasetDef.name, field];
        }
    }
}
exports.resolveField = resolveField;
function resolveKey(datasetDef) {
    if (datasetDef.keyField)
        return datasetDef.keyField;
    return datasetDef.name.replace(/-/g, '_') + '_' + datasetDef.tableType + '_key';
}
exports.resolveKey = resolveKey;
function resolveId(datasetDef) {
    if (datasetDef.idField)
        return datasetDef.idField;
    return 'torch_' + datasetDef.name.replace(/-/g, '_') + '_id';
}
exports.resolveId = resolveId;
function resolveFieldType(fieldType, datasetDef) {
    if (fieldType === 'id')
        return resolveId(datasetDef);
    else if (fieldType === 'key')
        return resolveKey(datasetDef);
}
exports.resolveFieldType = resolveFieldType;
